import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Formik } from "formik";
import { DialogContent, Stack, Typography } from "@mui/material";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import { updateQaQueueTeams } from "../../State/QaDuck";

export default function EnableDisableQTeam({ team }) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();

  return (
    <div>
      {team.active ? (
        <Button color="error" onClick={handleClickOpen}>
          Disable Team
        </Button>
      ) : (
        <Button color="secondary" onClick={handleClickOpen}>
          Enable Team
        </Button>
      )}

      <Dialog
        sx={{ border: "3px solid red" }}
        maxWidth="md"
        fullWidth
        open={open}
        onClose={handleClose}>
        <DialogTitle>Disable Team</DialogTitle>

        <Formik
          initialValues={{
            team_id: team.team_id,
            active: !team.active,
          }}
          validationSchema={Yup.object({
            active: Yup.boolean().required("Active is required"),
          })}
          onSubmit={(values) => {
            ///
            dispatch(updateQaQueueTeams(team.queue_id, values));
          }}>
          {() => (
            <Form>
              <DialogContent>
                <Stack spacing={2}>
                  <Typography variant="h6" gutterBottom>
                    {team.name}
                  </Typography>
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                {team.active ? (
                  <Button variant="contained" color="error" type="submit">
                    Disable Team
                  </Button>
                ) : (
                  <Button variant="contained" color="error" type="submit">
                    Enable Team
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
}
